<template>
  <!-- start divider -->
  <div id="divider">
    <div class="container">
      <div class="row">
        <div class="col-md-1 col-sm-1"></div>
        <div class="col-md-8 col-sm-8">
          <h2 class="wow bounce mark-primary" v-html="title"></h2>
          <h3 class="wow fadeIn" data-wow-delay="0.6s" v-html="subTitle"></h3>
          <p class="wow fadeInUp" data-wow-delay="0.9s" v-html="details"></p>
          <p class="wow fadeInUp" data-wow-delay="0.9s" v-html="more"></p>
          <tryBtn></tryBtn>
        </div>
        <div class="col-md-2 col-sm-2"></div>
      </div>
    </div>
  </div>
  <!-- end divider -->
</template>
<script>
  import tryBtn from './tryBtn'
  export default {
    name: 'divider',
    components: { tryBtn },
    data () {
      return {
        title: '<mark>Printer Counters</mark> collection software',
        subTitle: 'Collect printers counters automatically & schedule printer counters reports',
        details: 'Printer Counters Module automatically collects printer counters information from all printers in the organization – both network and local printers. Any make, a model of printer and any type of connection are supported. New network and connected locally printers are discovered automatically.',
        more: 'We collect print data as the number of pages printed or copied (including page size and color information), printer status, toner or ink level, IP address, model, serial number, MAC address. The collection of printer counters reports can be scheduled.'
      }
    },
    computed: {
    }
  }
</script>
<style>

  .mark-primary > mark {
    background-color: #fff;
    color: #2e5d79 !important;
  }
</style>



// WEBPACK FOOTER //
// divider.vue?211e2744